module.exports = __webpack_public_path__ + "static/media/reset.9efd8403.svg";